module.exports = __webpack_public_path__ + "img/ltl-3.21ff0098.png";